// extracted by mini-css-extract-plugin
module.exports = {"ratio_preview_box":"FJPreviewRatio_ratio_preview_box__R4hKE"};